import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class RakerApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }
  // LOGS
  getLogs (limit = 0, filter = null): Observable<any> {
    const APIEndPoint =
      filter != null
        ? `${environment.API_URL_RAKER}/logs?limit=${limit}&filter=${filter}`
        : `${environment.API_URL_RAKER}/logs?limit=${limit}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getLogsCountGroup (): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/logs/countGroup`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getLogsCountGroupDetails (): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/logs/countGroupDetails`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getLogsChangeFields (): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/logs/getChangeFieldLogs`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getLogsChangeFieldsAdmin (): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/logs/getChangeFieldLogsAdmin`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getUserLogs (): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/logs/userLogs`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getUserLogsCountGroupDetails (): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/logs/userCountGroupDetails`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  startRakerNow (idraker): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/rakerEngine/startRakerNow?id=${idraker}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  previewRaker (idraker, limit = 25): Observable<any> {
    const APIEndPoint = `${environment.API_URL_RAKER}/rakerEngine/previewRaker?id=${idraker}&limit=${limit}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }
}
